import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

function ModalAccept(props) {
  const {
    show = false,
    onAccept = () => {},
    onClose = () => {},
    run = '',
    nombre = '',
    apellido1 = '',
    apellido2 = '',
    nacimiento = '',
    sexo = '',
    genero = '',
    telefono = 'c',
    isapre = '',
    mail = '',
    direccion = '',
    nacionalidad = '',
    comunicacion = ''
  } = props


  return (
    <>
      <Modal show={show}>
        <Modal.Header className='d-flex justify-content-center'>
          <h4 className="m-0"> ¿Está seguro de los datos ingresados? </h4> 
          {/* <Modal.Title>  </Modal.Title> */}
        </Modal.Header>
        <Modal.Body> 
          <b> Rut: </b> { run } <br/>
          <b> Nombre: </b> { nombre }&nbsp;{ apellido1 }&nbsp;{ apellido2 } <br/>
          <b> Fecha de Nacimiento: </b> { nacimiento } <br/>
          { sexo && genero ?
            <> <b> Sexo: </b> { sexo } &emsp; <b> Género: </b> { genero } <br/> </>
            :
            sexo ?
            <> <b> Sexo: </b> { sexo } </>
            :
            genero ? 
            <> <b> Género: </b> { genero } <br/> </>
            :
            <></>
          }
          <b> Telefono: </b> { telefono } <br/>
          <b> Dirección: </b> { direccion } <br/>
          <b> Nacionalidad: </b> { nacionalidad } <br/>
          <b> Mail: </b> { mail } <br/>
          { isapre &&
            <> <b> Isapre: </b> { isapre } <br/> </>
          }
          { comunicacion &&
            <> <b> Comunicación: </b> { comunicacion } </>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onClose}>
            Cancelar
          </Button>
          <Button 
            className="btn-primary-ss" 
            block 
            onClick={onAccept}
            style={{width: 'fit-content'}}
          >
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAccept;